import text from './text/index.js';
import image from './graphics/image.js';
import svg from './graphics/svg.js';
import barcodes from './barcodes/index.js';
import line from './shapes/line.js';
import table from './tables/index.js';
import { rectangle, ellipse } from './shapes/rectAndEllipse.js';
import dateTime from './date/dateTime.js';
import date from './date/date.js';
import time from './date/time.js';
import radioButton from './radioButton/index.js';
import checkBox from "./checkBox/index.js";
import measurementPointList from './measurementPointList/index.js';
import measurementPointChart from './measurementPointChart/index.js';
import dropdown from "./dropdown/index.js";
import textInput from "./textInput/index.js";
import signature from "./signature/index.js";
import varText from "./varText/index.js";
const builtInPlugins = { Text: text };
export { builtInPlugins, 
// schemas
text, textInput, image, svg, table, barcodes, line, rectangle, ellipse, dateTime, date, time, dropdown, radioButton, checkBox, measurementPointList, measurementPointChart, signature, varText };
// Export utility functions
export { getDynamicHeightsForTable } from './tables/dynamicTemplate.js';
//# sourceMappingURL=index.js.map